import { Grid2 as Grid, Stack, Typography } from "@mui/material";
import Header from "./Header";
import * as d3 from "d3";
import { useEffect } from "react";
import { themeOptions } from "./theme";

export const About = () => {
  return (
    <Grid container>
      <Header />

      <Grid size={12}>
        <Stack
          m={10}
          mb={20}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"left"}
        >
          <Typography variant="h5" color="primary" gutterBottom>
            About Portland Dryer Mechanic
          </Typography>
          <Typography variant="body1" color="primary" mt={5}>
            Your trusted partner in dryer vent cleaning and maintenance in the
            Portland area! At Portland Dryer Mechanic, we specialize in
            preventing fire hazards and boosting your dryer's efficiency by
            thoroughly cleaning and maintaining dryer vents.
          </Typography>
          <Typography variant="body1" color="primary" mt={2}>
            Our mission is to deliver reliable, affordable, and prompt service
            to keep your home safe and your appliances running smoothly. Serving
            homeowners and businesses across the Portland Metropolitan area,
            we’re committed to providing top-notch care and peace of mind.
          </Typography>
          <Typography variant="body1" color="primary" mt={2}>
            Call today for a free estimate and experience the Portland Dryer
            Mechanic difference!
          </Typography>
          <Stack mt={5}>
            <Typography variant="h6" color="primary" mt={2}>
              Phone: 503-272-1113
            </Typography>
            <Typography variant="h6" color="primary" mt={2}>
              Email:{" "}
              <a href="mailto:cody@dryermechanic.com">
                {" "}
                cody@dryermechanic.com{" "}
              </a>
            </Typography>
          </Stack>
        </Stack>
      </Grid>
      {/* <Grid size={6} display={"flex"} justifyContent={"center"} mt={10}>
        <WashingMachineAnimation />
      </Grid> */}
    </Grid>
  );
};

const WashingMachineAnimation = () => {
  useEffect(() => {
    // Set up the SVG canvas
    const width = 500;
    const height = 500;

    const svg = d3
      .select("#washing-machine-container")
      .append("svg")
      .attr("width", width)
      .attr("height", height)
      .style("background-color", "#87CEEB"); // Light blue background

    // Define washing machine dimensions
    const machineWidth = 220;
    const machineHeight = 240;
    const machineX = (width - machineWidth) / 2;
    const machineY = (height - machineHeight) / 2;
    const machineRadius = 100;
    const centerX = width / 2;
    const centerY = height / 2;

    // Draw the outer washing machine with rounded edges
    const machine = svg
      .append("rect")
      .attr("x", machineX)
      .attr("y", machineY)
      .attr("width", machineWidth)
      .attr("height", machineHeight)
      .attr("rx", 20) // Rounded corners
      .attr("ry", 20) // Rounded corners
      .attr("fill", "#D3D3D3") // Light gray for the machine body
      .attr("stroke", "#A9A9A9") // Darker gray for the outline
      .attr("stroke-width", 5);

    // Draw the control panel
    const panelWidth = 150;
    const panelHeight = 50;
    const panelX = centerX + 90;
    const panelY = centerY - machineRadius - panelHeight - 90;

    const controlPanel = svg
      .append("rect")
      .attr("x", panelX)
      .attr("y", panelY)
      .attr("width", panelWidth)
      .attr("height", panelHeight)
      .attr("fill", "#A9A9A9") // Gray for the panel
      .attr("stroke", "#696969") // Darker gray for the outline
      .attr("stroke-width", 3);

    // Add buttons to the control panel
    const buttonsData = [
      {
        x: panelX + 20,
        y: panelY + 15,
        r: 8,
        color: "#303344",
      }, // Red button
      { x: panelX + 50, y: panelY + 15, r: 8, color: "#0288d1" }, // Yellow button
      { x: panelX + 80, y: panelY + 15, r: 8, color: "#ffeb3b" }, // Green button
    ];

    svg
      .selectAll("circle.button")
      .data(buttonsData)
      .enter()
      .append("circle")
      .attr("class", "button")
      .attr("cx", (d) => d.x)
      .attr("cy", (d) => d.y)
      .attr("r", (d) => d.r)
      .attr("fill", (d) => d.color);

    // Add dials to the control panel
    const dialsData = [
      { x: panelX + 110, y: panelY + 15, r: 10 },
      { x: panelX + 130, y: panelY + 15, r: 10 },
    ];

    svg
      .selectAll("circle.dial")
      .data(dialsData)
      .enter()
      .append("circle")
      .attr("class", "dial")
      .attr("cx", (d) => d.x)
      .attr("cy", (d) => d.y)
      .attr("r", (d) => d.r)
      .attr("fill", "#D3D3D3") // Light gray for the dials
      .attr("stroke", "#696969") // Darker gray for the outline
      .attr("stroke-width", 2);

    // Draw the inner drum
    const drumRadius = 70;
    const drum = svg
      .append("circle")
      .attr("cx", width / 2)
      .attr("cy", height / 2)
      .attr("r", drumRadius)
      .attr("fill", "#1E90FF") // Blue for the drum
      .attr("stroke", "#00008B") // Dark blue for outline
      .attr("stroke-width", 3);

    // Add lines for drum definition
    const lineAngles = [0, 60, 120, 180, 240, 300];
    svg
      .selectAll("line.drum-line")
      .data(lineAngles)
      .enter()
      .append("line")
      .attr("class", "drum-line")
      .attr("x1", width / 2)
      .attr("y1", height / 2)
      .attr("x2", (d) => width / 2 + drumRadius * Math.cos((d * Math.PI) / 180))
      .attr(
        "y2",
        (d) => height / 2 + drumRadius * Math.sin((d * Math.PI) / 180),
      )
      .attr("stroke", "#00008B")
      .attr("stroke-width", 2);

    // Define clothes as shapes
    const clothesData = [
      { x: 0, y: -40, size: 10, color: "#FF9800" }, // Yellow shirt
      { x: -25, y: 0, size: 15, color: "#FF6347" }, // Red sock
      { x: 7, y: 14, size: 12, color: "#0288d1" }, // Green towel
      { x: 30, y: 30, size: 20, color: "#32CD32" }, // Green towel
    ];

    // Define clothes as SVG elements
    const clothes = svg
      .selectAll("rect.cloth")
      .data(clothesData)
      .enter()
      .append("rect")
      .attr("class", "cloth")
      .attr("x", (d) => width / 2 + d.x - 10)
      .attr("y", (d) => height / 2 + d.y - 10)
      .attr("width", (d) => d.size)
      .attr("height", (d) => d.size)
      .attr("fill", (d) => d.color)
      .attr("rx", 2); // Rounded corners;

    // Add animation to the drum and clothes
    function spinDrum() {
      drum
        .transition()
        .duration(4000)
        .ease(d3.easeLinear)
        .attrTween("transform", () => {
          const interpolate = d3.interpolate(0, 360);
          return function (t: any) {
            return `rotate(${interpolate(t)} ${centerX} ${centerY})`;
          };
        })
        .on("end", spinDrum); // Repeat the animation

      clothes.each(function (d) {
        d3.select(this)
          .transition()
          .duration(4000)
          .ease(d3.easeLinear)
          .attrTween("transform", () => {
            const interpolate = d3.interpolate(0, 360);
            return function (t: any) {
              return `rotate(${interpolate(t)} ${width / 2} ${height / 2})`;
            };
          });
      });
    }

    spinDrum();

    return () => {
      d3.select("#washing-machine-container").select("svg").remove();
    };
  }, []);

  return <div id="washing-machine-container"></div>;
};
